import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import Button from './ui/Button.jsx';
import { navLinks } from '../data/practice.js';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close the drawer if the viewport widens past the mobile breakpoint so the
  // open state can't desync from the visible UI when rotating / resizing.
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 641px)');
    const onChange = (e) => {
      if (e.matches) setOpen(false);
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const closeDrawer = () => setOpen(false);

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        background: scrolled || open ? 'rgba(246,241,234,0.78)' : 'transparent',
        backdropFilter: scrolled || open ? 'blur(12px)' : 'none',
        WebkitBackdropFilter: scrolled || open ? 'blur(12px)' : 'none',
        boxShadow: scrolled ? '0 1px 0 rgba(45,42,38,0.06)' : 'none',
        transition: 'all 300ms var(--ease-out)',
      }}
    >
      <div
        className="nav-inner"
        style={{
          maxWidth: 'var(--maxw-content)',
          margin: '0 auto',
          padding: '18px var(--gutter)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
        }}
      >
        <a
          href="#top"
          onClick={closeDrawer}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 12,
            textDecoration: 'none',
          }}
        >
          <img
            src="/assets/logo-brain.png"
            alt=""
            className="nav-brand-logo"
            style={{ height: 40, width: 'auto' }}
          />
          <span
            className="nav-brand-text"
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 26,
              fontWeight: 400,
              color: 'var(--ink)',
              letterSpacing: '0.5px',
              lineHeight: 1,
            }}
          >
            Psycholoog <span style={{ fontStyle: 'italic' }}>Maxime</span>
          </span>
        </a>

        <ul
          className="nav-links"
          style={{ display: 'flex', gap: 32, listStyle: 'none', margin: 0, padding: 0 }}
        >
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: 14,
                  fontWeight: 400,
                  color: 'var(--ink)',
                  textDecoration: 'none',
                }}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="nav-cta" style={{ display: 'inline-flex' }}>
          <Button href="#contact">Afspraak maken</Button>
        </div>

        <button
          type="button"
          className="nav-toggle"
          aria-label={open ? 'Menu sluiten' : 'Menu openen'}
          aria-expanded={open}
          aria-controls="nav-drawer"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={22} strokeWidth={1.75} /> : <Menu size={22} strokeWidth={1.75} />}
        </button>
      </div>

      <div id="nav-drawer" className="nav-drawer" data-open={open}>
        {navLinks.map((l) => (
          <a key={l.href} href={l.href} onClick={closeDrawer}>
            {l.label}
          </a>
        ))}
        <div className="nav-drawer-cta">
          <Button href="#contact" onClick={closeDrawer} style={{ width: '100%', justifyContent: 'center' }}>
            Afspraak maken
          </Button>
        </div>
      </div>
    </nav>
  );
}
